import dayjs from "dayjs";

export const toAeroPayDateTime = (d, endOfDay = false) => {
  if (!d) return undefined;
  const base = endOfDay ? dayjs(d).endOf("day") : dayjs(d).startOf("day");
  return base.format("MM-DD-YYYY HH:mm:ss");
};

export const formatUnixSeconds = (unixSeconds) => {
  if (!unixSeconds) return "-";
  return new Date(Number(unixSeconds) * 1000).toLocaleString();
};

export const formatAmount = (v) => {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  if (!Number.isFinite(n)) return "-";
  return `$${n.toFixed(2)}`;
};
